module.exports = __webpack_public_path__ + "static/media/speaker-echo.1a497a8d.png";